import { LoadChildrenCallback, Routes } from '@angular/router';

import { environment } from '../../environments/environment';
import { Feature } from '../mtp-common/models';
import { AuthGuardService } from './guards/auth-guard.service';
import { FeatureGuard } from './guards/feature.guard';
import { TenantUnsetGuardService } from './guards/tenant-unset-guard.service';

type RouteResult = ReturnType<LoadChildrenCallback>;

export const routes: Routes = [
    {
        path: 'tenant',
        loadChildren: (): RouteResult => import('../mtp-tenant/mtp-tenant.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [TenantUnsetGuardService] : undefined,
    },
    {
        path: 'map',
        loadChildren: (): RouteResult => import('../mtp-main/mtp-main.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [AuthGuardService] : undefined,
    },
    {
        path: 'bulkPlanning',
        loadChildren: (): RouteResult => import('../mtp-bulk-planning/mtp-bulk-planning.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [AuthGuardService] : undefined,
    },
    {
        path: 'shared/:tenantId/:shareId',
        loadChildren: (): RouteResult => import('../mtp-shared-entity/mtp-shared-entity.routes').then((m) => m.routes),
    },
    {
        path: 'dev',
        loadChildren: (): RouteResult => import('../mtp-dev-portal/mtp-dev-portal.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [FeatureGuard.forFeature(Feature.DevPortal)] : undefined,
    },
    {
        path: 'sandbox',
        loadChildren: (): RouteResult => import('../mtp-sandbox/mtp-sandbox.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [FeatureGuard.forFeature(Feature.DevPortal)] : undefined,
    },
    {
        path: 'reporting',
        loadChildren: (): RouteResult => import('../mtp-reporting/mtp-reporting.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [AuthGuardService] : undefined,
    },
    {
        path: 'history',
        loadChildren: (): RouteResult => import('../mtp-history/mtp-history.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [AuthGuardService] : undefined,
    },
    {
        path: 'settings',
        loadChildren: (): RouteResult => import('../mtp-settings/mtp-settings.routes').then((m) => m.routes),
        canActivate: environment.authGuards ? [AuthGuardService] : undefined,
    },
    {
        path: '**',
        redirectTo: 'tenant',
    },
];
